import { useMemo } from 'react';

function useProductDetailValues(productDetail, locale) {
  return useMemo(
    () =>
      (productDetail?.values || [])
        .filter((detail) => !!detail.value || !!detail.valueText)
        .sort((detail1, detail2) => {
          if (!!detail1.productVariantValueId && !detail2.productVariantValueId) {
            return -1;
          }
          if (!detail1.productVariantValueId && !!detail2.productVariantValueId) {
            return 1;
          }
          if (detail1.id > detail2.id) {
            return 1;
          }
          if (detail1.id < detail2.id) {
            return -1;
          }
          if (detail1.field?.label?.[locale]?.localeCompare(detail2.field?.label?.[locale])) {
            return 1;
          }
          if (detail1.field?.label?.[locale]?.localeCompare(detail2.field?.label?.[locale])) {
            return -1;
          }
          return 0;
        })
        .map((detail) => ({ ...detail, id: detail.id || Math.random() })),
    [productDetail?.values]
  );
}

export default useProductDetailValues;
